export const clientConfig = {
    apiBaseUrl: /*'https://192.168.1.11:3001'*/'https://backend.tarbyarahima.com:3001',
};
export default clientConfig;